import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import { toDateFormatComma } from '~/shared/utils/date'
import DigitalLectureTag from './DigitalLectureTag'
import DigitalLectureMaterial from './DigitalLectureMaterial'
import DigitalLectureSpeaker from './DigitalLectureSpeaker'
import { ArticleMainItem } from '~/models/articles'

export default class DigitalLectureDetail extends BaseModel {
  static override constructorName = 'DigitalLectureDetail'

  id: number = 0
  slug: string = ''
  name: string = ''
  'date_publication': string = ''
  preview: string = ''
  'video_link': string = ''
  'video_file': string = ''
  'short_description': string = ''
  description: string = ''
  'is_published': boolean = false
  'category_id': number = 0
  'likes_count': number = 0
  'is_liked': boolean = false
  'views_count': number = 0
  'created_at': string = ''
  'updated_at': string = ''
  tags: DigitalLectureTag[] = []
  materials: DigitalLectureMaterial[] = []
  speakers: DigitalLectureSpeaker[] = []
  news: ArticleMainItem[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['tags', 'materials', 'speakers', 'news'])

      this.tags = convertToArrayModels(data.tags, DigitalLectureTag)
      this.materials = convertToArrayModels(data.materials, DigitalLectureMaterial)
      this.speakers = convertToArrayModels(data.speakers, DigitalLectureSpeaker)
      this.news = convertToArrayModels(data.news, ArticleMainItem)

      this.preview = toCroppedImage(this.preview)

      if (this.date_publication) {
        this.date_publication = toDateFormatComma(this.date_publication)
      }
    }
  }
}

registerModel(DigitalLectureDetail)
